import { render, staticRenderFns } from "./MatchVideoCenter.vue?vue&type=template&id=eff7f758&scoped=true"
import script from "./MatchVideoCenter.vue?vue&type=script&lang=js"
export * from "./MatchVideoCenter.vue?vue&type=script&lang=js"
import style0 from "./MatchVideoCenter.vue?vue&type=style&index=0&id=eff7f758&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff7f758",
  null
  
)

export default component.exports